export const ORDERING_HOLD = 'Ordering is not open yet. You can build and save your cart; no payment will be taken.';

export const isTenVialKit = (item) => /[x×]\s*10\s*vials/i.test(item.specification || '');
export const packageLabel = (item) => isTenVialKit(item) ? 'per kit' : 'per listed unit';
export const quantityLabel = (item) => isTenVialKit(item)
  ? `${item.quantity} ${item.quantity === 1 ? 'kit' : 'kits'} / ${item.quantity * 10} vials`
  : `${item.quantity} listed ${item.quantity === 1 ? 'unit' : 'units'}`;

// Preserve cart controls, but never substitute cached money for missing quote lines.
export function quotedCart(items, quote) {
  const byId = new Map((quote?.items || []).map(item => [item.product_id, item]));
  const unavailable = new Map((quote?.unavailable_items || []).map(item => [item.product_id, item]));
  return items.map(item => {
    const current = byId.get(item.product_id);
    return { ...item, unavailable: unavailable.has(item.product_id), price: current?.price ?? null, line_total: current?.line_total ?? null,
      priceChanged: !!current && Number(item.price) !== Number(current.price) };
  });
}

export function parseQuickOrder(text) {
  return text.split(/[,\n]+/).filter(line => line.trim()).map(line => {
    const match = line.trim().match(/^(.+?)\s+[x×*]?\s*(\d+)$/i)
      || line.trim().match(/^(.+?)[x×*](\d+)$/i);
    if (!match || !Number.isSafeInteger(Number(match[2])) || Number(match[2]) < 1 || Number(match[2]) > 999) {
      return { raw: line.trim(), error: 'Use SKU x quantity (1 to 999).' };
    }
    return { raw: line.trim(), sku: match[1].trim().toUpperCase(), qty: Number(match[2]) };
  });
}
